import slugify from 'slugify';
import { StorefrontECard } from '@components/storefront/StorefrontECard/StorefrontECard';
import { snakeToCamel } from './strings.util';
import { SignUpScenario } from '@utils/urlHelpers.util';

export const THEME_ID_META_KEY = 'theme_id';
const SHOPIFY_PRODUCT_TYPE_TO_SCENARIO_MAP: { [key in ShopifyProductType]: SignUpScenario } = {
  Invitation: 'invitation',
  'Save the Date': 'save-the-date',
} as const;

export const getSignUpScenario = (shopifyProductType: ShopifyProductType) => SHOPIFY_PRODUCT_TYPE_TO_SCENARIO_MAP[shopifyProductType];

export const eCardCategorySlugs = [
  'bold',
  'classic',
  'cultural',
  'destination',
  'floral-and-botanical',
  'metallic',
  'modern',
  'rustic',
  'seasonal',
  'textured',
] as const;

export type ECardCategorySlug = ElementType<typeof eCardCategorySlugs>;

const eCardCategorySlugsToTagsMap: { [key in ECardCategorySlug]: ReadonlyArray<ShopifyProductTag> } = {
  bold: ['Bold', 'Geometric', 'Bright', 'Typographic'],
  classic: ['Formal', 'Elegant', 'Romantic', 'Classic', 'Art Deco'],
  cultural: ['Cultural', 'Religious', 'Indian', 'Indonesian', 'Chinese', 'Japanese', 'Mexican'],
  destination: ['Destination', 'Beach', 'Mountains', 'Desert', 'Tropical', 'Nautical', 'City'],
  'floral-and-botanical': ['Floral', 'Botanical'],
  metallic: ['Metallic'],
  modern: ['Modern', 'Geometric', 'Minimal', 'Black & White', 'Typographic'],
  rustic: ['Rustic', 'Country', 'Mountains', 'Forest'],
  seasonal: ['Seasonal', 'Summer', 'Winter', 'Fall', 'Spring'],
  textured: ['Textured', 'Watercolor', 'Paper', 'Marble', 'Paint'],
};

export const getECardTagsByCategory = (categorySlug: ECardCategorySlug) => {
  return eCardCategorySlugsToTagsMap[categorySlug];
};

const invitationDesignsRoute = '/wedding-invitations/designs/';
const saveTheDateDesignsRoute = '/save-the-date/designs/';
export const invitationDesignsCanonicalUrl = `https://withjoy.com${invitationDesignsRoute}`;
export const saveTheDateDesignsCanonicalUrl = `https://withjoy.com${saveTheDateDesignsRoute}`;

const baseProductRoutesMap: { [key in ShopifyProductType]: string } = {
  Invitation: invitationDesignsRoute,
  'Save the Date': saveTheDateDesignsRoute,
};

export const getECardsCategoryRoute = (productType: 'Save the Date' | 'Invitation', categorySlug: ECardCategorySlug | undefined) => {
  return `${baseProductRoutesMap[productType]}${categorySlug ? categorySlug + '/' : ''}`;
};

export const getUseTemplateCtaId = (productType: string, themeId: string) => {
  return snakeToCamel(`use-${slugify(productType)}-template-${slugify(themeId)}`);
};

export const getCardThemeId = (card: StorefrontECard) => {
  return card.metafields.find(metafield => metafield.key === THEME_ID_META_KEY)?.value;
};
